module.exports = __webpack_public_path__ + "static/como-funciona-integracao-mobile-faf85f56b4a2eb8344495ee91ee1a290.svg";